import React, { useState, Fragment, useEffect, useRef, createContext } from 'react';
import { useFormContext, Controller, ErrorMessage } from 'react-hook-form';
import { useStyle } from './style';
import {
	Paper, Grid,
	TextField,
	Tooltip,
	Typography, FormControl,
	Select, MenuItem, InputLabel
} from '@material-ui/core';
import HelpOutlinedIcon from '@material-ui/icons/HelpOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import errormesages from './errormessages';
import axios from 'axios';
import { set } from 'core-js/core/dict';
export default function EirCustomerAccountDetails(props) {
	const { register, errors, control, setError, clearError, setValue, getValues } = useFormContext();
	const { validation } = errormesages;
	const classes = useStyle();
	const phoneInputRef = useRef();
	const accountInputRef = useRef();
	const prefixInputRef = useRef();
	const [areaCode, setAreaCode] = useState(null);
	const [prefix, setPrefix] = useState(null);
	const [checkStatus, setCheckStatus] = useState(false);
	const loginSuccessStatus = props.loginSuccess;
	const [accNo, setAccNo] = useState(null);
	const [accNumber, setAccNumber] = useState(null);
	const [phoneNumber, setPhoneNumber] = useState(null);
	const [number, setNumber] = useState(null);
	const [phPrefix, setPhPrefix] = useState('');
	const [disable, setDisable] = useState(false);

	useEffect(() => {

		if (loginSuccessStatus || (sessionStorage.getItem("existingCustomerAccNum") && sessionStorage.getItem("existingCustomerBundleDetails"))) {
			setAccNo(null);
			setNumber(null);
			setPhPrefix(null);
			setDisable(false);
			setAccNo(JSON.parse(sessionStorage.getItem("existingCustomerAccNum")));
			if (accNo !== null) {
				setValue('eirAccountNo', accNo, { shouldDirty: true });    //setting account number for existing customers on login
			}
			if (JSON.parse(sessionStorage.getItem("existingCustomerBundleDetails")) && (JSON.parse(sessionStorage.getItem("existingCustomerBundleDetails")).data.bundles != null)) {
				var getExistingCustomerBundleDetails = JSON.parse(sessionStorage.getItem("existingCustomerBundleDetails")).data.bundles.bundles[0];
				for (var i = 0; i < getExistingCustomerBundleDetails.subProducts.length; i++) {
					if (getExistingCustomerBundleDetails.subProducts[i].subProductType === "INTERNET") {	// broadband line
						setNumber(getExistingCustomerBundleDetails.subProducts[i].subProductTelephoneNumber.split('-')[1]);
						setValue('eirPhoneNo', number, { shouldDirty: true });
						setPhPrefix(getExistingCustomerBundleDetails.subProducts[i].subProductTelephoneNumber.split('-')[0]);
						setPrefix(phPrefix);
						setValue('prefix', phPrefix, { shouldDirty: true });
						//console.log("inside if loop1, phPrefix", i, phPrefix);
					}
				}
				if (number == null && phPrefix == null) {
					for (var i = 0; i < getExistingCustomerBundleDetails.subProducts.length; i++) {
						if (getExistingCustomerBundleDetails.subProducts[i].subProductType === "FIXED_LINE") {// landline 
							setNumber(getExistingCustomerBundleDetails.subProducts[i].subProductTelephoneNumber.split('-')[1]);
							setValue('eirPhoneNo', number, { shouldDirty: true });
							setPhPrefix(getExistingCustomerBundleDetails.subProducts[i].subProductTelephoneNumber.split('-')[0]);
							setPrefix(phPrefix);
							setValue('prefix', phPrefix, { shouldDirty: true });
							//console.log("inside if loop2, phPrefix", i, phPrefix);
						}
					}
				}
				if (number == null && phPrefix == null) {
					setValue('eirPhoneNo', '', { shouldDirty: true });
					setValue('prefix', '', { shouldDirty: true });
					//console.log("user has no internet or fixedline");	// remove phone number if new login user has no broadband/landline number
				}
			}
			else {
				setValue('eirPhoneNo', '', { shouldDirty: true });
				setValue('prefix', '', { shouldDirty: true });
			}
			setDisable(true);
		}

	}, [loginSuccessStatus, phPrefix, number, accNo, disable]);

	useEffect(() => {
		if (!areaCode) {
			let areaCodes = '/json/areacodes.txt';
			fetch(areaCodes)
				.then((response) => {
					return response.json()
				})
				.then((data) => {
					setAreaCode(data.areacodes);
				})
				.catch((err) => {
					console.log(">>>>>>>Error in fetching the areacodes - ", err);
				})
		} else
			getCmsCheck();
	}, [prefix, number, accNumber, accNo]);

	const handleaccNum = (event) => {
		event.preventDefault();
		setAccNumber(event.target.value);
	}

	async function getCmsCheck() {
		try {
			//console.log("prefix, phprefix getcmscheck>>", prefix, phPrefix);
			loginSuccessStatus && setPrefix(phPrefix);
			var phoneVal = loginSuccessStatus ? number : phoneInputRef.current.value;
			var accountVal = loginSuccessStatus ? accNo : accountInputRef.current.value;
			//console.log("phone val and acc val and prefix>>>", phoneVal, accountVal, prefix);
			if (prefix && phoneVal && accountVal) {
				let urlPath = '/store/api/checkout/cms-check/' + accountVal + '/' + prefix + '/' + phoneVal;
				let res = await axios({
					url: urlPath,
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
					}
				})
				if (res.status == 200) {
					if (res.data.valid) {
						setCheckStatus(true);
						clearError('prefix');
						clearError('eirPhoneNo');
						clearError('eirAccountNo');
					} else {
						setCheckStatus(false);
						setError('prefix', 'manual', validation.invalidAccount);
						setError('eirPhoneNo', 'manual', validation.invalidAccount);
						setError('eirAccountNo', 'manual', validation.invalidAccount);
					}
				} else {
					console.log('Generic error!');
				}
			}
		}
		catch (err) {
			console.error(err);
		}
		//console.log('Prefix root>>>', prefix);
		//console.log('phoneNumber root>>>', phoneVal);
		let accountDetails = { prefix: prefix, phoneNumber: phoneVal };
		sessionStorage.setItem('accountDetails', JSON.stringify(accountDetails));
	}
	return (
		<Fragment>
			{/*contact information */}
			<Grid item sm={12} className={classes.contactPadding}>
				<Paper className={classes.contactPaper} variant='elevation' elevation={4}>
					<Grid container>
						<Grid item sm={6}>
							<Grid container>
								<Grid item sm={7}>
									<h2 className={classes.contactTxt}>
										eir Account Details
									</h2>
								</Grid>
							</Grid>
						</Grid>
						<Grid item sm={6} xs={12}>
							<Typography className={classes.reqText}><span style={{ color: 'red', textAlign: 'center' }} >*</span> Required Fields</Typography>
						</Grid>
					</Grid>
					<Grid container sm={12} xs={12}
					>
						<Grid item sm={1} xs={12} spacing={3} className={classes.accountPrefix}>
							<FormControl variant="outlined" fullWidth size="small" color="secondary" className={classes.dropDownMinWidth}>
								<InputLabel required
									//shrink={loginSuccessStatus && true}
									error={Boolean(errors.prefix)}
								>Prefix</InputLabel>
								<Controller
									control={control}
									name="prefix"
									id="prefix"
									inputRef={prefixInputRef}
									defaultValue={phPrefix}
									value={phPrefix}
									error={Boolean(errors.prefix)}
									onFocus={() => {
										prefixInputRef.current.focus();
									}}
									rules={{ required: { value: true, message: validation.invalidAccount } }}
									as={
										<Select
											id="prefix"
											label="Prefix"
											disabled={disable}
										>
											{areaCode ? areaCode.map((code) =>
												<MenuItem key={code.code} value={code.code} className={classes.selectLabel}>
													{code.code}
												</MenuItem>
											) : ''}
										</Select>
									}
									onChange={([event]) => {
										//setPrefix(event.target.value);
										(loginSuccessStatus || (phPrefix != "")) ? setPrefix(phPrefix) : setPrefix(event.target.value);
										return event.target.value;
									}}
								/>
							</FormControl>
						</Grid>
						<Grid item sm={4} xs={11} className={classes.paddingRightItem}>
							<Controller
								as={<TextField color="secondary" />}
								inputRef={(loginSuccessStatus || (number != null)) ? register : phoneInputRef}
								control={control}
								fullWidth
								id="eirPhoneNo"
								name="eirPhoneNo"
								label="eir Phone Number"
								variant="outlined"
								size="small"
								InputLabelProps={(number) && { shrink: true }}
								disabled={disable}
								error={Boolean(errors.eirPhoneNo)}
								onFocus={() => {
									phoneInputRef.current.focus();
								}}
								required
								rules={{
									required: { value: true, message: validation.invalidAccount },
									pattern: { value: /^[0-9]*$/, message: validation.landLinePattern }
								}}
								onChange={([event]) => {
									getCmsCheck();
									return event.target.value;
								}}
							/>
							{errors.prefix ?
								<Grid className={classes.errorMessageHeight}>
									<ErrorMessage errors={errors} name='prefix'>
										{({ message }) => <p className={classes.errorMessage}>{message}</p>}
									</ErrorMessage>
								</Grid>
								:
								<Grid className={classes.errorMessageHeight}>
									<ErrorMessage errors={errors} name="eirPhoneNo">
										{({ message }) => <p className={classes.errorMessage}>{message}</p>}
									</ErrorMessage>
								</Grid>
							}
						</Grid>
						<Grid item sm={1} xs={1}>
							<Tooltip
								enterTouchDelay={20}
								leaveTouchDelay={15000}
								title="Please enter your home phone number."
								placement='right'>
								{checkStatus ?
									<CheckCircleOutlineIcon
										style={{ color: '#892BA0', marginTop: '10px' }}
										className={classes.questionIcon}
									/>
									: <HelpOutlinedIcon
										style={{ color: '#892BA0', marginTop: '10px' }}
										className={classes.questionIcon}
									/>
								}

							</Tooltip>
						</Grid>
						<Grid item sm={5} xs={11} className={classes.paddingLeftItem}>
							<Controller
								as={<TextField color="secondary" />}
								inputRef={(loginSuccessStatus || (JSON.parse(sessionStorage.getItem("existingCustomerAccNum")))) ? register : accountInputRef}
								control={control}
								fullWidth
								id="eirAccountNo"
								name="eirAccountNo"
								label="eir Account Number"
								InputLabelProps={(accNo) && { shrink: true }}
								variant="outlined"
								size="small"
								disabled={disable}
								error={Boolean(errors.eirAccountNo)}
								onFocus={() => {
									accountInputRef.current.focus();
								}}
								required
								rules={{
									required: { value: true, message: validation.invalidAccount },
									pattern: { value: /^[0-9]*$/, message: validation.invalidAccount },
									maxLength: { value: 8, message: validation.invalidAccount }
								}}
								onChange={([event]) => {
									handleaccNum(event);
									getCmsCheck();
									return event.target.value;
								}}
							/>
							<Grid className={classes.errorMessageHeight}>
								<ErrorMessage errors={errors} name="eirAccountNo">
									{({ message }) => <p className={classes.errorMessage}>{message}</p>}
								</ErrorMessage>
							</Grid>
						</Grid>
						<Grid item sm={1} xs={1}>
							<Tooltip
								enterTouchDelay={20}
								leaveTouchDelay={15000}
								title="eir Account number is 8 digits long"
								placement='right'>
								{checkStatus ?
									<CheckCircleOutlineIcon
										style={{ color: '#892BA0', marginTop: '10px', marginLeft: '1rem' }}
										className={classes.questionIcon}
									/>
									: <HelpOutlinedIcon
										style={{ color: '#892BA0', marginTop: '10px', marginLeft: '1rem' }}
										className={classes.questionIcon}
									/>
								}
							</Tooltip>
						</Grid>
					</Grid>
				</Paper>
			</Grid>
		</Fragment>
	);
}